import { actionTypes } from '../../../types';

// Action creator for generating OTP request
export const createCampaignByAgency = (payload, callback) => ({
    type: actionTypes.CREATE_CAMPAIGN_BY_AGENCY_REQUEST,
    payload,
    callback
});

// Action creator for successful OTP generation
export const createCampaignByAgencySuccess = (payload) => ({
    type: actionTypes.CREATE_CAMPAIGN_BY_AGENCY_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const createCampaignByAgencyFailure = (payload) => ({
    type: actionTypes.CREATE_CAMPAIGN_BY_AGENCY_FAILURE,
    payload,
});

// Action creator for resetting OTP generation status
export const createCampaignByAgencyReset = () => ({
    type: actionTypes.CREATE_CAMPAIGN_BY_AGENCY_RESET,
});

// Action creator for resetting all OTP generation reducer
export const createCampaignByAgencyResetAll = () => ({
    type: actionTypes.CREATE_CAMPAIGN_BY_AGENCY_RESET_ALL,
}); 